export const settings = {
    en: {
        'Confirm Saving Credentials': 'Confirm Saving Credentials',
        'You are about to save without providing any': 'You are about to save without providing any',
        Production: 'Production',
        Test: 'Test',
        credentials: 'credentials',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        'The same credentials are shared with all': 'The same credentials are shared with all',
        'payment applications in this store and customers will not be able to complete payments in':
            'payment applications in this store and customers will not be able to complete payments in',
        mode: 'mode',
        Please: 'Please',
        'to proceed or': 'to proceed or',
        'to edit': 'to edit',
        'Credentials Saved Successfully': 'Credentials Saved Successfully',
        'Production Credentials Saved Successfully': 'Production Credentials Saved Successfully',
        'Test Credentials Saved Successfully': 'Test Credentials Saved Successfully',
        'Production credentials were': 'Production credentials were',
        cleared: 'cleared',
        valid: 'valid',
        'Production credentials were invalid': 'Production credentials were invalid',
        'Test credentials were': 'Test credentials were',
        'Test credentials were invalid': 'Test credentials were invalid',
        'You can proceed to activate the payment application, but it will only work in test mode':
            'You can proceed to activate the payment application, but it will only work in test mode',
        'You can proceed to activate the payment application, but it will only work in production mode':
            'You can proceed to activate the payment application, but it will only work in production mode',
        'to proceed to Shopify to activate the payment application':
            'to proceed to Shopify to activate the payment application',
        'to stay on this page': 'to stay on this page',
        'Saving Credentials Failed': 'Saving Credentials Failed',
        'Please check your credentials and try again': 'Please check your credentials and try again',
        Settings: 'Settings',
        'Merchant Credentials': 'Merchant Credentials',
        'These credentials are used to process payments': 'These credentials are used to process payments',
        'Available default test credentials': 'Available default test credentials',
        Copied: 'Copied',
        Copy: 'Copy',
        Save: 'Save',
    },
    fi: {
        'Confirm Saving Credentials': 'Vahvista tunnusten tallennus',
        'You are about to save without providing any': 'Olet tallentamassa ilman',
        Production: 'Tuotanto',
        Test: 'Testi',
        credentials: 'tunnukset',
        Confirm: 'Vahvista',
        Cancel: 'Peruuta',
        'The same credentials are shared with all': 'Näitä kauppias tunnuksia käytetään kaikissa',
        'payment applications in this store and customers will not be able to complete payments in':
            'maksutavoissa tässä kaupassa ja asiakkaat eivät pysty luomaan maksuja',
        mode: 'tilassa',
        Please: 'Ole hyvä',
        'to proceed or': 'jatkaaksesi tai',
        'to edit': 'muuttaaksesi',
        'Credentials Saved Successfully': 'Kauppiastunnukset tallennettu onnistuneesti',
        'Production Credentials Saved Successfully': 'Tuotantokauppiastunnukset tallennettu onnistuneesti',
        'Test Credentials Saved Successfully': 'Testikauppiastunnukset tallennettu onnistuneesti',
        'Production credentials were': 'Syötetyt kauppiastunnukset ovat',
        cleared: 'poistettu',
        valid: 'oikein',
        'Production credentials were invalid': 'Syötetyt tuotantokauppiastunnukset ovat virheelliset',
        'Test credentials were': 'Testikauppiastunnukset ovat',
        'Test credentials were invalid': 'Syötetyt testitunnukset ovat virheelliset',
        'You can proceed to activate the payment application, but it will only work in test mode':
            'Voit jatkaa maksutavan aktivointiin, mutta maksutapa toimii vain testitilassa',
        'You can proceed to activate the payment application, but it will only work in production mode':
            'Voit jatkaa maksutavan aktivointiin, mutta maksutapa toimii vain tuotantotilassa',
        'to proceed to Shopify to activate the payment application':
            'siirtyäksesi takaisin Shopifyn asetuksiin ja aktivoidaksesi maksutavan',
        'to stay on this page': 'pysyäksesi tällä sivulla',
        'Saving Credentials Failed': 'Tunnusten tallennus epäonnistui',
        'Please check your credentials and try again': 'Ole hyvä ja tarkista kauppiastunnukset.',
        Settings: 'Asetukset',
        'Merchant Credentials': 'Kauppiastunnukset',
        'These credentials are used to process payments': 'Näitä tunnuksia käytetään maksujen prosessointiin',
        'Available default test credentials': 'Saatavilla olevat yleiset testitunnukset',
        Copied: 'Kopioitu',
        Copy: 'Kopioi',
        Save: 'Tallenna',
    },
    sv: {
        'Confirm Saving Credentials': 'Bekräfta att spara inloggningsuppgifter',
        'You are about to save without providing any': 'You are about to save without providing any',
        Production: 'Handlarkoder',
        Test: 'Test',
        credentials: 'koder',
        Confirm: 'Bekräfta',
        Cancel: 'Avbryt',
        'The same credentials are shared with all': 'Samma handlarkoder delas med alla',
        'payment applications in this store and customers will not be able to complete payments in':
            'payment applications in this store and customers will not be able to complete payments in',
        mode: 'mode',
        Please: 'Vänligen',
        'to proceed or': 'för att fortsätta eller',
        'to edit': 'att redigera',
        'Credentials Saved Successfully': 'Inloggningsuppgifterna har sparats',
        'Production Credentials Saved Successfully': 'Handlarkoderna har sparats',
        'Test Credentials Saved Successfully': 'Testkoderna har sparats',
        'Production credentials were': 'De angivna Handlar-ID:n är',
        cleared: 'raderade',
        valid: 'korrekta',
        'Production credentials were invalid': 'De angivna Handlar-Id:na är felaktiga',
        'Test credentials were': 'De angiva testkoderna är',
        'Test credentials were invalid': 'De angiva testkoderna är felaktiga',
        'You can proceed to activate the payment application, but it will only work in test mode':
            'Du kan fortsätta att aktivera betalningsmetoden, men betalningsmetoden fungerar bara i testläge.',
        'You can proceed to activate the payment application, but it will only work in production mode':
            'Du kan fortsätta att aktivera betalningsmetoden, men betalningsmetoden fungerar bara i produktionsläge.',
        'to proceed to Shopify to activate the payment application':
            'för att fortsätta till Shopify inställningarna för att aktivera betalningsmetoden.',
        'to stay on this page': 'för att stanna kvar på den här sidan',
        'Saving Credentials Failed': 'Sparandet av koderna misslyckades',
        'Please check your credentials and try again': 'Vänligen kontrollera Handlarkoderna.',
        Settings: 'Inställningar',
        'Merchant Credentials': 'Handlarkoder',
        'These credentials are used to process payments':
            'Dessa inloggningsuppgifter används för att behandla betalningar',
        'Available default test credentials': 'Tillgängliga vanliga testidkoder',
        Copied: 'kopieras',
        Copy: 'Kopiera',
        Save: 'Spara',
    },
};
